import { render, staticRenderFns } from "./announcement-list.vue?vue&type=template&id=61db7222&scoped=true"
import script from "./announcement-list.vue?vue&type=script&lang=js"
export * from "./announcement-list.vue?vue&type=script&lang=js"
import style0 from "./announcement-list.vue?vue&type=style&index=0&id=61db7222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db7222",
  null
  
)

export default component.exports